export default __webpack_public_path__ + "static/media/robot-base-optimization.fe64bc1c.md";